import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg sticky-top">
        <div className="container">
          <Link to="/dashboard">
            <img
              src="/assets/images/logo-red.png"
              width="100"
              className="me-5"
            />
          </Link>
          <div className="ms-auto d-flex align-items-center">
            <div className="dropdown me-1">
              <Link
                to="/dashboard"
                className="btn btn-light btn-icon rounded-circle d-flex align-items-center"
              >
                <i className="bi bi-house" />
              </Link>
            </div>
            <div className="dropdown me-1">
              <Link
                to="/notification"
                className="btn btn-light btn-icon rounded-circle d-flex align-items-center"
              >
                <i className="bi bi-bell" />
              </Link>
            </div>
            <div className="dropdown me-1">
              <Link
                to="/membership"
                className="dropdown-item rounded-pill bg-light fs-5"
              >
                <i className="bi bi-cart3 me-2" />
                Membership
              </Link>
            </div>
            <ul className="navbar-nav navbar-right-wrap d-flex nav-top-wrap">
              <li className="dropdown stopevent">
                <Link
                  to="/history"
                  className="btn btn-light btn-icon rounded-circle indicator indicator-primary"
                >
                  <i className="bi bi-wallet" />
                </Link>
              </li>
              <li className="dropdown ms-2">
                <a className="rounded-circle">
                  <div
                    onClick={handleLogout}
                    className="avatar avatar-md avatar-indicators avatar-online"
                  >
                    <img
                      alt="avatar"
                      src="https://cdn-icons-png.flaticon.com/512/10309/10309341.png"
                      className="rounded-circle"
                    />
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
